import { render, staticRenderFns } from "./VEmojiPicker.vue?vue&type=template&id=0a0a88b6&"
import script from "./VEmojiPicker.vue?vue&type=script&lang=js&"
export * from "./VEmojiPicker.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_gwqqbdtstrkazc3c5tmodvvd2i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports